import React from 'react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿Funciona para principiantes?',
    a: '✅ Sí, desde el primer tomo.'
  }, {
    q: '¿Y para instructores con experiencia?',
    a: '✅ Sí, especialmente Tomos 4, 5 y 6.'
  }, {
    q: '¿Puedo verlo en el móvil?',
    a: '✅ Sí, PDF optimizado para móvil.'
  }, {
    q: '¿Los bonos están incluidos?',
    a: '✅ Sí, sin coste extra en ambos packs.'
  }, {
    q: '¿Qué diferencia hay entre los dos packs?',
    a: '✅ El Pack Completo incluye el S.R.I. — el sistema para retener alumnos 12 meses y escalar tu negocio como instructor autónomo.'
  }];
  return <Section data-id="element-125">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-126">
        ❓ FAQ Rápido
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-127">
        {faqs.map((faq, i) => <div key={i} className="bg-gradient-card border border-brand-border rounded-xl p-6 shadow-card hover:shadow-violet-glow transition-all hover:border-brand-borderGlow/40" data-id="element-128">
            <h3 className="font-heading font-bold text-lg text-brand-subtitle mb-2 tracking-wide" data-id="element-129">
              {faq.q}
            </h3>
            <p className="font-body text-brand-text" data-id="element-130">{faq.a}</p>
          </div>)}
      </div>
    </Section>;
}